import React from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import commonService from 'utils/commonService';
import { IProps } from './types';

const BuildingInfo: React.FC<IProps> = (props) => {
  const resources = useSelector((state: RootReducersState) => state.resources);
  return (
    <div className="building-info">
      <div className="building-info__title">{commonService.getNameByLng(resources, 'TID_Building_information')}</div>
      <div className="building-info__content">
        <div className="element__list">
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insured_address')}</div>
              <div className="element__list-group-content">
                {
                  props.ADDRESS_FULL ? props.ADDRESS_FULL : '-'
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Floor_number')}</div>
              <div className="element__list-group-content">
                {
                  props.BUILDING_OUTLINE ? props.BUILDING_OUTLINE : '-'
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Usage_area')}</div>
              <div className="element__list-group-content">
                {
                  props.USAGE_AREA ? `${props.USAGE_AREA}坪` : '-'
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Construction_year')}</div>
              <div className="element__list-group-content">
                {
                  props.BUILDING_YEAR ? `民國${+props.BUILDING_YEAR}年` : '-'
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Building_structure')}</div>
              <div className="element__list-group-content">
                {
                  props.BUILDING_STRUCTURE ? props.BUILDING_STRUCTURE : '-'
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Roof_type')}</div>
              <div className="element__list-group-content">
                {
                  props.ROOF_STRUCTURE ? props.ROOF_STRUCTURE : '-'
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildingInfo;
